import * as Sentry from '@sentry/react'
import { AxiosError } from 'axios'

export const logRequestError = (
  error: AxiosError & { pathTemplate?: string; pathParams?: Record<string, string> },
  _extra?: Record<string, any>
) => {
  if (!error.config) {
    Sentry.captureException(error, { extra: { logRequestError: 'error.config undefined' } })
    return
  }

  const errorName = `${error.config.method?.toUpperCase()} ${
    error.pathTemplate || error.config.url
  } ${error.response?.status}`

  if (import.meta.env.PROD || import.meta.env.VITE_DEBUG_SENTRY) {
    const extra: Record<string, any> = { ..._extra }

    if (error.response?.data) {
      extra.response = error.response?.data
    }
    if (error.pathParams) {
      extra.pathParams = error.pathParams
    }

    error.name = errorName

    Sentry.captureException(error, { extra })
  } else {
    console.error(`logRequestError: "${errorName}"`, error.response?.data)
  }
}
